import { clsx } from 'clsx';

import { Tooltip } from '@treezor/design-system';

import { DashboardHelpers } from '@/utils/DashboardHelpers';

const MAX_LENGTH = 30;

interface IPaymentTruncateCellProps {
  textString?: string;
  className?: string;
  tooltipClassName?: string;
}

export function PaymentTruncateCell({ textString, className, tooltipClassName }: IPaymentTruncateCellProps) {
  if (!textString) return <>/</>;

  return (
    <>
      {textString?.length > MAX_LENGTH ? (
        <Tooltip messageContent={textString} contentClassName={clsx('min-w-[180px]', tooltipClassName)}>
          <span className={clsx('typo-body-regular-paragraph text-secondary', className)}>
            {DashboardHelpers.truncateText(textString, MAX_LENGTH)}
          </span>
        </Tooltip>
      ) : (
        <span className={clsx('typo-body-regular-paragraph text-secondary', className)}>{textString}</span>
      )}
    </>
  );
}
